var _defs, _polygon, _path, _polyline, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAssets12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 209.67 63.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3, .st4 {\n        fill: #ffd100;\n      }\n\n      .st1 {\n        stroke: #ffd510;\n        stroke-width: .33px;\n      }\n\n      .st1, .st2 {\n        stroke-miterlimit: 10;\n      }\n\n      .st4 {\n        opacity: .14;\n      }\n\n      .st5 {\n        opacity: .3;\n      }\n\n      .st2 {\n        stroke: #ffd100;\n        stroke-width: .46px;\n      }\n\n      .st6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 80.39,
    y: 52.39,
    width: 91,
    height: 9.08
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193.5 30.28 193.5 11.38 54.52 11.38 54.52 52.39 171.4 52.39 193.5 30.28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.73,52.39H7.08V11.38h41.65v41.01ZM7.4,52.07h41.01V11.7H7.4v40.37Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "108.88 2.29 202.59 2.29 202.59 34.05 175.17 61.47 7.08 61.47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 97.37,
    y1: 45.58,
    x2: 86.43,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 101.03,
    y1: 45.58,
    x2: 90.09,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 104.69,
    y1: 45.58,
    x2: 93.75,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 108.36,
    y1: 45.58,
    x2: 97.42,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 112.02,
    y1: 45.58,
    x2: 101.08,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 115.68,
    y1: 45.58,
    x2: 104.74,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 119.35,
    y1: 45.58,
    x2: 108.41,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.01,
    y1: 45.58,
    x2: 112.07,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 126.67,
    y1: 45.58,
    x2: 115.73,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.34,
    y1: 45.58,
    x2: 119.4,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134,
    y1: 45.58,
    x2: 123.06,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.66,
    y1: 45.58,
    x2: 126.72,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.33,
    y1: 45.58,
    x2: 130.39,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 144.99,
    y1: 45.58,
    x2: 134.05,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.65,
    y1: 45.58,
    x2: 137.71,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.32,
    y1: 45.58,
    x2: 141.38,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 155.98,
    y1: 45.58,
    x2: 145.04,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.64,
    y1: 45.58,
    x2: 148.7,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 163.31,
    y1: 45.58,
    x2: 152.37,
    y2: 61.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 166.97,
    y1: 45.58,
    x2: 156.03,
    y2: 61.47
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAssets12);
export default __webpack_public_path__ + "static/media/SVG_assets-12.552aa164ddd160e77f6cfda071dba813.svg";
export { ForwardRef as ReactComponent };